<style lang="scss">
$teal:      #5bb8b1;
$teal-dark: #2c7d76;
$teal-bg:   #e4f3f0;
$font:      'Segoe UI', system-ui, sans-serif;

.bn-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100vw;
  background: $teal-dark;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 9999;
  font-family: $font;

  @media (min-width: 768px) { padding: 14px 32px; }
}

.bn-footer__total {
  color: #fff;
  font-family: $font;
  line-height: 1.2;

  small {
    font-size: 11px;
    opacity: 0.75;
    display: block;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .bn-footer__amount {
    font-size: 20px;
    font-weight: 700;

    @media (max-width: 480px) { font-size: 18px; }
  }
}

.bn-footer__actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.bn-footer__back {
  height: 38px;
  padding: 0 18px;
  border-radius: 8px;
  border: 1.5px solid rgba(255, 255, 255, 0.5);
  background: transparent;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 7px;
  transition: background 0.15s, border-color 0.15s;
  font-family: $font;
  outline: none;

  &:hover  { background: rgba(255,255,255,0.12); border-color: #fff; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
}

.bn-footer__next {
  height: 38px;
  padding: 0 22px;
  border-radius: 8px;
  border: none;
  background: #fff;
  color: $teal-dark;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 7px;
  transition: background 0.15s, box-shadow 0.15s;
  font-family: $font;
  outline: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);

  &:hover  { background: $teal-bg; box-shadow: 0 4px 14px rgba(0,0,0,0.16); }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
}
</style>

<template>
  <div id="book-footer-temp" class="bn-footer">
    <div class="bn-footer__total" v-if="totalamount != ''">
      <small>Total</small>
      <span class="bn-footer__amount">${{ totalamount }}</span>
    </div>
    <div v-else></div>

    <div class="bn-footer__actions">
      <button
        class="bn-footer__back"
        @click.prevent="back()"
        v-if="backname != ''"
      >
        <i class="fa fa-arrow-left"></i> {{ backname }}
      </button>
      <button
        class="bn-footer__next"
        :disabled="getWizardFormButtonDisable"
        :id="[btnname == 'Submit' ? 'drugsubmit' : '']"
        @click.prevent="next()"
        ref="kt_submit"
      >
        {{ btnname }} <i :class="'fa ' + nextbtnicon"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    btnname:     { type: String, default: "Button" },
    nextbtnicon: { type: String, default: "fa-arrow-right" },
    backname:    { type: String, default: "Back" },
    totalamount: { type: String, default: "" }
  },
  computed: {
    ...mapGetters(["getAbbreviationCode", "getWizardFormButtonDisable"])
  },
  methods: {
    next() { this.$emit("next"); },
    back() { this.$emit("back"); }
  }
};
</script>
